import React, { useContext, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import clsx from "clsx";

import { makeStyles, alpha } from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";
import { MoreVert, Replay, GetApp, Block, HowToReg, Edit, OpenInNew, Search } from "@material-ui/icons";
import { SwapHoriz as SwapHorizIcon, SmartToy as SmartToyIcon } from "@mui/icons-material";
import ConfirmationModal from "../ConfirmationModal";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
// import TicketOptionsMenu from "../TicketOptionsMenu";
import TransferTicketModal from "../TransferTicketModal";
import ButtonWithSpinner from "../ButtonWithSpinner";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";
import { AuthContext } from "../../context/Auth/AuthContext";
import { Menu, MenuItem, Tooltip } from "@mui/material";
import TicketTransferirModal from "../TicketTransferirModal";
import ExportTicketModal from "../ExportTicketModal";
import { podeAlternarIa } from "../../helpers/botaoIa";
import { urlLeadNoCrm } from "../../helpers/urlRetornoCrm";

const http = require('http');

const init = {
	host: 'localhost',
	path: '/zdgProtocolo',
	port: 8080,
	method: 'POST',
	headers: {
		'content-type': 'application/json; charset=utf-8'
	}
};

const init2 = {
	host: 'localhost',
	path: '/zdgSendEmail',
	port: 8080,
	method: 'POST',
	headers: {
		'content-type': 'application/json; charset=utf-8'
	}
};

const callback = function (response) {
	let result = Buffer.alloc(0);
	response.on('data', function (chunk) {
		result = Buffer.concat([result, chunk]);
	});

	response.on('end', function () {
		console.log(result.toString());
	});
};

async function ZDGProtocolo(usuario, protocolo) {
	const req = http.request(init, callback);
	const body = `{"usuario":"` + usuario + `","protocolo":"` + protocolo + `"}`;
	await req.write(body);
	req.end();
}

async function ZDGEmail(zdgSubject, zdgText) {
	const req = http.request(init2, callback);
	const body = `{"zdgSubject":"` + zdgSubject + `","zdgText":"` + zdgText.replace(/\n/g, "\\n") + `"}`;
	await req.write(body);
	req.end();
}

const useStyles = makeStyles(theme => {
	const escuro = theme.palette.type === "dark";
	// Tom do ícone: no escuro o .dark fica sem contraste sobre o fundo tingido.
	const verde = escuro ? theme.palette.success.light : theme.palette.success.dark;
	const vermelho = escuro ? theme.palette.error.light : theme.palette.error.dark;

	// Estado do botão de IA: fundo tingido + borda da cor, em vez de botão sólido
	// verde/vermelho, que ficaria estridente no cabeçalho.
	const estadoIa = (cor, corIcone) => ({
		color: corIcone,
		backgroundColor: alpha(cor, escuro ? 0.2 : 0.12),
		borderColor: alpha(cor, 0.5),
		"&:hover": {
			color: corIcone,
			backgroundColor: alpha(cor, escuro ? 0.3 : 0.2),
			borderColor: cor,
		},
	});

	return {
		actionButtons: {
			display: "flex",
			alignItems: "center",
			gap: theme.spacing(1),
			flex: "none",
		},
		// Botões um pouco maiores (padding 8 + ícone tamanho padrão de 24px = ~40px)
		// e com fundo de superfície, pra terem mais presença no cabeçalho.
		iconBtn: {
			color: theme.palette.text.secondary,
			backgroundColor: theme.palette.background.paper,
			border: `1px solid ${theme.palette.divider}`,
			borderRadius: 10,
			padding: 8,
			// Tamanho do ícone fixo pra todos os botões ficarem iguais: os ícones do
			// @material-ui/icons (v4) usam pxToRem, que aqui é escalado pelo
			// typography.fontSize 10 do tema e sai ~17px, enquanto os do
			// @mui/icons-material (v5) saem 24px. Sem isso o "mais ações" (MoreVert,
			// v4) ficava menor que os de IA e transferir.
			"& .MuiSvgIcon-root": {
				fontSize: 24,
			},
			"&:hover": {
				backgroundColor: theme.palette.action.hover,
				color: theme.palette.primary.main,
				borderColor: theme.palette.primary.main,
			},
		},
		iconBtnAtivo: {
			color: theme.palette.primary.main,
			borderColor: theme.palette.primary.main,
		},
		iaAtiva: estadoIa(theme.palette.success.main, verde),
		iaInativa: estadoIa(theme.palette.error.main, vermelho),

		// ACEITAR / Reabrir: mesma altura (40) e mesmo raio (10) dos botões de
		// ícone, sem sombra, pra não destoarem da fileira. O position relative é
		// exigência do ButtonWithSpinner (ele posiciona o spinner absoluto e o
		// className que passamos substitui o dele).
		statusBtn: {
			position: "relative",
			height: 40,
			borderRadius: 10,
			paddingLeft: 16,
			paddingRight: 16,
			whiteSpace: "nowrap",
			boxShadow: "none",
			fontSize: theme.typography.button.fontSize,
			"&:hover": {
				boxShadow: "none",
			},
		},
	};
});

const TicketActionButtons = ({ ticket, onBuscar, buscaAberta }) => {
	const { ticketId } = useParams();
	const classes = useStyles();
	const history = useHistory();
	const [anchorEl, setAnchorEl] = useState(null);
	const [loading, setLoading] = useState(false);
	const [ticketTransferirModalOpen, setTicketTransferirModalOpen] = useState(false);
	const [exportModalOpen, setExportModalOpen] = useState(false);
	const [confirmIaOpen, setConfirmIaOpen] = useState(false);
	// const ticketOptionsMenuOpen = Boolean(anchorEl);
	const { user } = useContext(AuthContext);
	const date = new Date();
	// const minutes = date.getMinutes();
	// const hour = date.getHours();

	const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
	const isMounted = useRef(true);

	const handleSendMessage = async (status, userId) => {
		const message = {
			read: 1,
			fromMe: true,
			mediaUrl: "",
			body: "Seu protocolo de atendimento é: *nº " + Math.floor(Date.now() / 1000) + '*',
		};
		try {
			// const { data } = await api.get("/tickets/" + ticketId);
			// ZDGProtocolo(data.contact.number, Math.floor(Date.now() / 1000).toString());
			await api.post(`/messages/${ticketId}`, message);
			alert('Protocolo de atendimento:' + Math.floor(Date.now() / 1000));
			await api.put(`/tickets/${ticket.id}`, {
				status: status,
				userId: userId || null,
			});
			// ZDGEmail('Ticket ' + ticketId + ' acaba de ser finalizado.', 'O atendente acaba de fechar o ticket nº ' + ticketId + '\nNúmero de contato: ' + data.contact.number + '\nNome ' + data.contact.name + '\nHorário ' + hour + ':' + minutes)
		} catch (err) {
			toastError(err);
		}
	};

	// const handleOpenTicketOptionsMenu = e => {
	// 	setAnchorEl(e.currentTarget);
	// };

	// const handleCloseTicketOptionsMenu = e => {
	// 	setAnchorEl(null);
	// };

	const handleAcepptTicket = async (id) => {
		setLoading(true);
		try {
			await api.put(`/updateNovoLead/${id}`, {
				status: "open",
				userId: user?.id,
			});
		} catch (err) {
			setLoading(false);
			toastError(err);
		}
		if (isMounted.current) {
			setLoading(false);
		}
		history.push(`/tickets/${id}`);
	};

	const handleReopenTicket = async (e, userId) => {
		setLoading(true);
		try {
			await api.post(`/reopenticket/${ticket.id}`, {
				userId,
				lead_icode: ticket.lead_icode
			});
			setLoading(false);
			history.push(`/tickets/${ticket.id}`);
		} catch (err) {
			setLoading(false);
			toastError(err);
		}
	};

	const handleSaveTicket = async e => {
		e.preventDefault();
		if (!ticket.id) return;
		setLoading(true);
		try {
			await api.put(`/ticketsassumir/${ticket.lead_icode}/${user.id}`);

			setLoading(false);
			history.push(`/tickets/${ticket.id}`);
			setAnchorEl(null);
		} catch (err) {
			setLoading(false);
			toastError(err);
		}
	};

	// Antes eram handleAtivarIa/handleDesativarIa, idênticos a não ser pelos
	// booleanos. Agora é um só, chamado depois da confirmação, e alterna pelo
	// estado atual do ticket.
	const handleAlternarIa = async () => {
		if (!ticket.id) return;
		const ativar = !ticket.atendimentoIa;
		setLoading(true);
		try {
			await api.post(`/atendimentoIa/${ticket.id}`, {
				atendimentoIa: ativar,
				enviarParaIa: ativar
			});

			setLoading(false);
			history.push(`/tickets/${ticket.id}`);
			setAnchorEl(null);
		} catch (err) {
			setLoading(false);
			toastError(err);
		}
	};

	const handleOpenTransferModal = e => {
		setTransferTicketModalOpen(true);
		setAnchorEl(null);
	};

	const handleCloseTransferTicketModal = () => {
		if (isMounted.current) {
			setTransferTicketModalOpen(false);
		}
	};

	const handleTransferirLead = async (value) => {
		if (value) {
			try {
				await api.post(`/transferirlead`, {
					userLogadoId: user?.id,
					userDestinoId: value,
					leads: [ticket.id]
				});
			} catch (err) {
				toastError(err);
			}
		}
		setTicketTransferirModalOpen(false);
	};

	const handleOpenMenu = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleOpenExportModal = () => {
		setExportModalOpen(true);
		setAnchorEl(null);
	};

	const handleCloseMenu = async (menu) => {
		if (menu === "transferLead") {
			setTicketTransferirModalOpen(true);
		}
		if (menu === "blacklist") {
			try {
				await api.post(`/blacklist/bulk`, {
					ticketIds: [ticketId],
					createdBy: user?.id
				});
			} catch (err) {
				toastError(err);
			}
		}
		setAnchorEl(null);
	};

	return (
		<div className={classes.actionButtons}>
			{/* Pesquisar na conversa aberta: abre o painel lateral (mesmo lugar dos dados do contato). */}
			{onBuscar && (
				<Tooltip title="Pesquisar na conversa">
					<IconButton
						onClick={onBuscar}
						size="small"
						aria-label="Pesquisar na conversa"
						className={clsx(classes.iconBtn, buscaAberta && classes.iconBtnAtivo)}
					>
						<Search />
					</IconButton>
				</Tooltip>
			)}

			{/* IA: botão próprio (saiu do menu). Verde = IA ativa neste ticket,
				vermelho = desativada. Tons suaves (fundo tingido + borda), não sólidos.
				A regra de quando ele aparece está no helper porque o aviso da barra de
				digitação (InputBloqueado) manda desativar a IA aqui — os dois têm que
				concordar sobre o botão existir. */}
			{podeAlternarIa(user, ticket) && (
				<Tooltip title={ticket.atendimentoIa ? "IA ativa — clique para desativar" : "IA desativada — clique para ativar"}>
					<IconButton
						onClick={() => setConfirmIaOpen(true)}
						disabled={loading}
						size="small"
						aria-label={ticket.atendimentoIa ? "Desativar IA" : "Ativar IA"}
						className={clsx(classes.iconBtn, ticket.atendimentoIa ? classes.iaAtiva : classes.iaInativa)}
					>
						<SmartToyIcon />
					</IconButton>
				</Tooltip>
			)}

			{/* Transferir lead: também ganhou botão próprio. Mesmas condições que
				tinha como item de menu. Grupo não tem lead nem atendente — nada a
				transferir (o !isGroup cobre grupo antigo que ainda tem lead_icode). */}
			{ticket.status === "open" && ticket.lead_icode && !ticket.isGroup && (user.id == ticket.userId || user.gestor) && (
				<Tooltip title="Transferir lead">
					<IconButton
						onClick={() => setTicketTransferirModalOpen(true)}
						disabled={loading}
						size="small"
						aria-label="Transferir lead"
						className={classes.iconBtn}
					>
						<SwapHorizIcon />
					</IconButton>
				</Tooltip>
			)}

			<div>
				{/* Menu de mais ações. Renderizado em qualquer status porque agora
					guarda o "Exportar conversa", que antes era botão fixo e vale pra
					ticket fechado/aguardando também. */}
				<Tooltip title="Mais ações">
					<IconButton
						onClick={handleOpenMenu}
						size="small"
						aria-label="Mais ações"
						className={classes.iconBtn}
					>
						<MoreVert />
					</IconButton>
				</Tooltip>

				{/* O sx do Menu normaliza os ícones dos itens (tamanho + espaço), assim
					não importa se o ícone vem do pacote v4 ou v5 — a especificidade de
					duas classes ganha do fontSize próprio do SvgIcon nos dois casos. */}
				<Menu
					anchorEl={anchorEl}
					open={Boolean(anchorEl)}
					onClose={handleCloseMenu}
					sx={{ "& .MuiSvgIcon-root": { fontSize: 18, marginRight: 1 } }}
				>
					<MenuItem onClick={handleOpenExportModal}>
						<GetApp />
						Exportar conversa
					</MenuItem>
					{/* Assumir lead: além das condições de sempre (conversa aberta de OUTRO
						atendente, e grupo não tem lead), exige a permissão do cadastro do
						usuário no ERP — renderBotaoAssumir. Quem não tem não vê o item, e a
						rota também recusa (ver TicketController.assumirLead): esconder aqui
						é só visual, a conversa pode ser aberta direto pela URL. */}
					{user.renderBotaoAssumir && ticket.status === "open" && user.id != ticket.userId && !ticket.isGroup && (
						<MenuItem disabled={loading} onClick={e => handleSaveTicket(e)}>
							<HowToReg />
							Assumir lead
						</MenuItem>
					)}
					{/* Grupo: só "Alterar grupo" (nome, etiqueta e observações). Não tem
						lead, então não existe CRM pra abrir nem etapa/filial/agendamento pra
						mexer; blacklist também não vale pra grupo (AddTicketsToBlacklist
						já ignora ticket de grupo). */}
					{ticket.isGroup && (
						<MenuItem disabled={loading} onClick={e => handleOpenTransferModal(e)}>
							<Edit />
							Alterar grupo
						</MenuItem>
					)}
					{!ticket.isGroup && ticket.status === "open" && ticket.lead_icode && (user.id == ticket.userId || user.gestor)
						&& (<>
							<MenuItem disabled={loading} onClick={e => handleOpenTransferModal(e)}>
								<Edit />
								Alterar lead
							</MenuItem>

							<MenuItem disabled={loading} onClick={() => {
								const url = urlLeadNoCrm(ticket.lead_icode);
								if (!url) {
									toast.error("Não foi possível identificar o endereço do ERP desta sessão. Entre no Whaticket pelo ERP para usar este atalho.");
									return;
								}
								window.open(url, "_blank");
							}}>
								<OpenInNew />
								Acessar lead no CRM
							</MenuItem>

							{/* Ação destrutiva no padrão do MUI, igual à barra de múltipla
								seleção (antes era backgroundColor: 'red' cravado). */}
							<MenuItem
								onClick={(e) => { handleCloseMenu("blacklist"); e.stopPropagation(); }}
								sx={{ color: "error.main" }}
							>
								<Block />
								Adicionar à blacklist
							</MenuItem>
						</>)}
				</Menu>
			</div>

			{/* Botões de status direto na fileira (o Box com width 100% / mx auto saiu:
				com um botão só ele não fazia nada além de reservar largura). A classe
				statusBtn dá a eles a mesma altura e o mesmo raio dos botões de ícone —
				o ACEITAR segue preenchido de azul, por ser a ação principal.
				Os "Ativar IA"/"Desativar IA" que ficavam aqui (só no status pending)
				saíram: o botão de IA no topo cobre todos os status. */}
			{ticket.status === "closed" && (
				<ButtonWithSpinner
					loading={loading}
					startIcon={<Replay />}
					size="small"
					variant="outlined"
					className={classes.statusBtn}
					onClick={e => handleReopenTicket(e, user?.id)}
				>
					{i18n.t("messagesList.header.buttons.reopen")}
				</ButtonWithSpinner>
			)}

			{ticket.status === "pending" && (
				<ButtonWithSpinner
					loading={loading}
					size="small"
					variant="contained"
					color="primary"
					disableElevation
					className={classes.statusBtn}
					onClick={e => handleAcepptTicket(ticketId)}
				>
					ACEITAR
				</ButtonWithSpinner>
			)}

			{/* Modais ficam fora do Box: são portais, não ocupam espaço no
				cabeçalho, e dentro dele viravam item flex com gap. */}
			<TransferTicketModal
				modalOpen={transferTicketModalOpen}
				onClose={handleCloseTransferTicketModal}
				ticketid={ticket.id}
				isGroup={!!ticket.isGroup}
				userId={user.id}
				leadId={ticket.lead_icode}
				funil_icode={ticket.funil_icode}
				nomeT={ticket.contact?.name}
				obs={ticket.observacao}
				agenda={ticket.agendamento}
				etapa={ticket.queueId}
				tag={ticket.tagId}
				filialIdTicket={ticket.filial_icode}
			/>
			<TicketTransferirModal
				modalOpen={ticketTransferirModalOpen}
				user={user}
				onClose={(value) => handleTransferirLead(value)}
			/>
			<ExportTicketModal
				open={exportModalOpen}
				onClose={() => setExportModalOpen(false)}
				ticket={ticket}
			/>
			<ConfirmationModal
				title={ticket.atendimentoIa ? "Desativar IA neste atendimento?" : "Ativar IA neste atendimento?"}
				open={confirmIaOpen}
				onClose={() => setConfirmIaOpen(false)}
				onConfirm={handleAlternarIa}
			>
				{ticket.atendimentoIa
					? "A IA para de responder este contato e o atendimento volta a ser manual."
					: "A IA passa a responder este contato automaticamente."}
			</ConfirmationModal>
		</div >
	);
};

export default TicketActionButtons;
